<template>
	<div class="app-input-container mb-3" :class="placement ? placement : ''">
		<div :class="['relative w-full justify-center', { 'app-datepicker-right': position === 'right' }]">
			<transition name="slide-fade" mode="out-in">
				<app-label v-if="initialValue || d" :for="name" color="secondary">
					{{ $attrs.placeholder }}
				</app-label>
			</transition>

			<datepicker
				class="app-datepicker"
				ref="DatePickerComponent"
				:modelValue="value"
				@update:modelValue="valueChanged"
				:placeholder-attr="$attrs.placeholder"
				:disabled="$attrs.disabled"
				:lowerLimit="lowerLimit"
			/>
			<transition name="slide-fade-reverse">
				<span
					class="error-message text-13 text-error"
					v-if="validation.meta.touched || validation.errors.length > 0"
				>
					{{ validation.errorMessage }}
				</span>
			</transition>
		</div>
	</div>
</template>

<script>
	import datepicker from 'vue3-datepicker';
	import AppLabel from '@/components/typography/AppLabel';
	import moment from 'moment';

	export default {
		name: 'AppDatepicker',
		components: {
			datepicker,
			AppLabel,
		},
		props: {
			name: {},
			initialValue: {},
			placement: {},
			locale: {
				type: Object,
				default: () => ({
					format: 'YYYY-MM-DD',
				}),
			},
			validation: {
				type: Object,
				default: () => ({
					meta: {},
					errors: [],
				}),
			},
			position: {
				type: String,
				default: 'left',
			},
			lowerLimit: {
				default: null,
			},
		},
		emits: ['selected'],
		data: () => ({
			d: null,
		}),
		computed: {
			value() {
				return moment(this.initialValue).toDate();
			},
		},
		methods: {
			valueChanged(event) {
				const formattedDate = moment(event).format('YYYY-MM-DD');
				this.d = formattedDate;
				this.$emit('selected', formattedDate);
			},
		},
	};
</script>
